import React, { useEffect } from "react";
import { Button, Drawer, Form, Input, InputNumber, Select, Space } from "antd";
import {
  enumOptions,
  normalizeAnswerOptionsForForm,
  normalizeAnswerOptionsForPayload,
} from "./utils";
import {
  CHOICE_ANSWER_TYPES,
  JobOpportunityQuestionAnswerType,
  JobOpportunityQuestionAnswerValueType,
} from "./questionEnums";
import AnswerOptionsField from "./AnswerOptionsField";

export default function JobOpportunityQuestionDrawer({
  open,
  onClose,
  onSubmit,
  loading,
  initialValues,
}) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!open) return;
    form.resetFields();
    if (initialValues) {
      form.setFieldsValue({
        ...initialValues,
        answerOptions: normalizeAnswerOptionsForForm(initialValues.answerOptions),
      });
    }
  }, [open, form, initialValues]);

  const handleFinish = async (values) => {
    await onSubmit({
      ...values,
      answerOptions: CHOICE_ANSWER_TYPES.includes(values.answerType)
        ? normalizeAnswerOptionsForPayload(values.answerOptions)
        : null,
      orderNumber:
        values.orderNumber === "" || values.orderNumber === null
          ? undefined
          : values.orderNumber,
    });
  };

  return (
    <Drawer
      title={initialValues?.id ? "Edit Job Question" : "Create Job Question"}
      width={760}
      open={open}
      onClose={onClose}
      destroyOnClose
      placement="right"
      zIndex={2000}
      footer={
        <Space style={{ width: "100%", justifyContent: "flex-end" }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" loading={loading} onClick={() => form.submit()}>
            Save
          </Button>
        </Space>
      }
    >
      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <Form.Item
          name="question"
          label="Question"
          rules={[{ required: true, message: "Question is required" }]}
        >
          <Input.TextArea rows={3} placeholder="Enter the question" />
        </Form.Item>
        <Form.Item
          name="orderNumber"
          label="Order Number"
          rules={[{ required: true, message: "Order number is required" }]}
        >
          <InputNumber min={1} max={50} style={{ width: "100%" }} />
        </Form.Item>
        <Form.Item
          name="answerType"
          label="Answer Type"
          rules={[{ required: true, message: "Answer type is required" }]}
        >
          <Select options={enumOptions(JobOpportunityQuestionAnswerType)} />
        </Form.Item>
        <Form.Item
          name="answerValueType"
          label="Answer Value Type"
          rules={[{ required: true, message: "Answer value type is required" }]}
        >
          <Select options={enumOptions(JobOpportunityQuestionAnswerValueType)} />
        </Form.Item>
        <Form.Item name="answerMetric" label="Answer Metric">
          <Input placeholder="e.g. years, score, amount" />
        </Form.Item>
        <AnswerOptionsField />
      </Form>
    </Drawer>
  );
}
